$(document).ready(function(){
  $('input[name="contact[phone]"]').keyup(function() {
 if (/\D/g.test(this.value)) this.value = this.value.replace(/\D/g,'');
})
  $('.buy_now_cstm').click(function(){
    var id= $(this).attr('data-id');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id :id, quantity: 1 },
      dataType : 'json',
      async :false,
      success: function(result){
        console.log(result);
        location.href = '/cart';
      },
      error : function(){
        console.log('error');
      }
    });
  });
    $('.announcement_wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows:false,
      vertical: true,
      dots:false
    });

 // -------------------------------desktop menu 
  if($(window).width() > 1023){
   $('.cstm__Shop .navmenu-item a.navmenu-link-depth-3').mouseenter(function(e){
     // console.log(e.target);
     // if(e.target != 'forth_menus'){
     $('.cstm__forth_level').hide();
     $(this).parent().find('.cstm__forth_level').show();
     // }
   });
    $('body').on('mouseenter','.cstm__Shop details[open="open"]',function(){
      $('.cstm__forth_level').hide();
      // $(this).find('.cstm__parent_menu').eq(0).find('.cstm__forth_level').show();
       $(this).find('.navmenu-item').eq(0).find('.cstm__forth_level').show();
      $('.cstm__Shop details').removeClass('nav_active');
      $(this).addClass('nav_active');
    });
    $('body').on('mouseenter','.cstm_have_nochild',function(){
      $('.cstm__Shop details').removeClass('nav_active');
    })
// $('body').on('mouseleave','.navmenu-meganav--desktop.cstm__Shop',function(){
//   if(!$(this):is(':visible')){
//   $('.cstm__Shop details').removeClass('nav_active');
//   }
//   });
    
  }
  // ------------------------------End desktop menu
  // ------------------------------Mobile menu
  if($(window).width() < 1024){
  $('body').on('click','.cstm__parent_menu',function(e){
    e.preventDefault();
   $(this).find('.cstm__forth_level').slideToggle();
   $(this).toggleClass('active_cstm_nav');
  });
    $('body').on('click','.navmenu-link,.forth_menus',function(e){
     e.preventDefault();
      console.log($(this).next().next().className)
      $(this).next().next().hide();
     var url = $(this).attr('href');
      window.location.href=url;
    })
  }
  // ------------------------------End mobile menu

   // search menu 
  if($(window).width() > 1023){
   $('.site-header-main span.form-field-select-wrapper.live-search-filter-wrapper').mouseenter(function(){
    $('.search_navigation_cstm').show();
    // $('ul.search_subnav_cstm').fadeOut('fast');
    //  $(this).find('.search_nav_cstm li').eq(0).find('ul').fadeIn();
     $('ul.search_subnav_cstm').css('opacity',0);
     $('ul.search_subnav_cstm').css('visibility','hidden');
     $(this).find('.search_nav_cstm li').eq(0).find('ul').css('opacity',1);
     $(this).find('.search_nav_cstm li').eq(0).find('ul').css('visibility','visible');
     $('.search-flydown[data-animation-state=open]').hide();
   }); 
    $('.site-header-main span.form-field-select-wrapper.live-search-filter-wrapper').mouseleave(function(){
    $('.search_navigation_cstm').hide();
    $('.search-flydown[data-animation-state=open]').show();  
   });
    $('.cstm_search_nav-1').mouseenter(function(){
    // $('ul.search_subnav_cstm').fadeOut('fast');
    // $(this).parent().find('ul').fadeIn();
       $('ul.search_subnav_cstm').css('opacity',0);
      $('ul.search_subnav_cstm').css('visibility','hidden');
    $(this).parent().find('ul').css('opacity',1);
       $(this).parent().find('ul').css('visibility','visible');
    })
  }
  // End search menu
// $('.image_count').click(function() {
// $('.gallery-navigation--scroller').slick({
//   slidesToShow: 6,
//   slidesToScroll: 1,
//   asNavFor: '.new_slider_hero_img',
//   prevArrow: '<button type="button" data-role="none" class="left_arrow_thumb" role="button"></button>',
//   nextArrow: '<button type="button" data-role="none" class="right_arrow_thumb" role="button"></button>',   
// });
// $(this).parents('.product-gallery').find('.product-gallery--video-thumbnail').hide();
// $(this).parents('.product-gallery').find('.product-gallery--image-thumbnail').show();
// });

// $('.video_count').click(function() {
// $('.gallery-navigation--scroller').slick('unslick');
// $(this).parents('.product-gallery').find('.product-gallery--image-thumbnail').hide();
// $(this).parents('.product-gallery').find('.product-gallery--video-thumbnail').show();
// }); 
});


// for showing the slider in hero image and thumb image
$(document).ready(function(){
//   if($(window).width() > 719){
// $('.new_slider_hero_img').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   speed: 1000,
//   asNavFor: '.gallery-navigation--scroller',
//   arrow: true,
//   prevArrow: '<button type="button" data-role="none" class="left_arrow_hero_img" role="button"></button>',
//   nextArrow: '<button type="button" data-role="none" class="right_arrow_hero_img" role="button"></button>', 
 
// });
  
// $('.gallery-navigation--scroller').slick({
//   slidesToShow: 6,
//   slidesToScroll: 1,
//   asNavFor: '.new_slider_hero_img',
//   prevArrow: '<button type="button" data-role="none" class="left_arrow_thumb" role="button"></button>',
//   nextArrow: '<button type="button" data-role="none" class="right_arrow_thumb" role="button"></button>',   
// });
//   }
  // sort by
  $('.cstm__sort_by_button button').click(function(){
    $('.utils-sortby--modal-list').slideToggle();
    $(this).parent().toggleClass('activetab_nav',1000);
  })
  
  // End sort by
});


 $(document).ready(function(){
     $('.product-gallery--video-thumbnail').hide();
    thumb_imgslider('.product-gallery--image-thumbnail');
  function  thumb_imgslider(slider){
    // desktop thumbnails
    $('.gallery-navigation--scroller').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  slide:slider,
  prevArrow: '<button type="button" data-role="none" class="left_arrow_thumb" role="button"></button>',
  nextArrow: '<button type="button" data-role="none" class="right_arrow_thumb" role="button"></button>',   
  arrows:true
});
  }
$('.image_count').click(function(){
$('.gallery-navigation--scroller').slick('unslick'); 
$('.product-gallery--video-thumbnail').hide();
$('.product-gallery--image-thumbnail').show();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
 thumb_imgslider('.product-gallery--image-thumbnail');
});
    $('.video_count').click(function(){
    $('.gallery-navigation--scroller').slick('unslick');  
    $('.product-gallery--image-thumbnail').hide();
    $('.product-gallery--video-thumbnail').show();
    thumb_imgslider('.product-gallery--video-thumbnail');
    });

    $('body').on('click','.main_image_next',function(){
      var media_id = $(this).attr('media_id');
      var current_id = $(`.gallery-navigation--scroller .product-gallery--media-thumbnail[data-media=${media_id}]+.product-gallery--media-thumbnail`).attr('data-media');
      $(this).attr('media_id',current_id);
      $('.main_image_pre').attr('media_id',current_id);
      $(`.gallery-navigation--scroller .product-gallery--media-thumbnail[data-media=${media_id}]+.product-gallery--media-thumbnail`).trigger('click');
       $('button.right_arrow_thumb.slick-arrow').trigger('click');
     });

     $('body').on('click','.main_image_pre',function(){
      var media_id = $(this).attr('media_id');
      var current_id = $(`.gallery-navigation--scroller .product-gallery--media-thumbnail[data-media=${media_id}]`).prev().attr('data-media');
      $(this).attr('media_id',current_id);
       $('.main_image_next').attr('media_id',current_id);
      $(`.gallery-navigation--scroller .product-gallery--media-thumbnail[data-media=${media_id}]`).prev().trigger('click');
        $('button.left_arrow_thumb.slick-arrow').trigger('click');
     });

       if($(window).width() > 720){
      $('body').on('click','button.right_arrow_thumb.slick-arrow',function(){
      $('.product-gallery--media-thumbnail.slick-current').trigger('click');
      }); 
      $('body').on('click','button.left_arrow_thumb.slick-arrow',function(){
      $('.product-gallery--media-thumbnail.slick-current').trigger('click');
      });  
       $('body').on('click','.product-gallery--media-thumbnail',function(){
       $('.product-gallery--media-thumbnail').removeClass('slick-current');
          $(this).addClass('slick-current');
       })
     }

     $('body').on('click','.live-search-button',function(){
        var val = $('.live-search-form-field').val();
        var search_url = `/search?type=article%2Cpage%2Cproduct&q=${val}*`;
        window.location.href=search_url;
      });
      $('body').on('keyup', '.live-search-form-field', function (e) {
         var key = e.which;
         if(key == 13){
          var val = $('.live-search-form-field').val();
          var search_url = `/search?type=article%2Cpage%2Cproduct&q=${val}*`;
          window.location.href=search_url;
        }
      });
      $('body').on('click','[mb-name="cart"] a',function(e){
        $('[mb-name]').removeClass('active');
        $(this).parent().addClass('active');
        e.preventDefault();
        setTimeout(function(){
        $('a#cart_drawer_icon').trigger('click');
          }, 100);
      })
    
  });
// order cancel and return  kapture crm api start
$(document).ready(function () {
            let CancelData = []
            let ReasonCancelData;
            let Tgtcancelreason = document.querySelectorAll(".return_input_menu li");
            Tgtcancelreason.forEach((item) => {
                item.addEventListener('click', function () {
                    ReasonCancelData = item.textContent;
                    // console.log("reasonText" , reasonText)
                    // console.log("ReasonCancelData", ReasonCancelData)
                })
            })
            let tgtcancelsubmitbtn = document.getElementById("return-cancel-btn")
            tgtcancelsubmitbtn.addEventListener('click', function () {
                let tgtCancelField = document.querySelectorAll(".return_input_info input");
                tgtCancelField.forEach((item) => {
                    // console.log("itemmm"  , item.value)
                    CancelData.push(item.value)
                })

                let tgtcancelTextArea = document.getElementById("return_message")
                CancelData.push(tgtcancelTextArea.value)
                CancelData.push(ReasonCancelData)
                // console.log("CancelData", CancelData)
                let url = `https://vkcnuts.com/kapture.php?title=${encodeURIComponent("title")}&brand=vkcnuts&ticket=bb&due_date=2023-08-03&reason=${encodeURIComponent(CancelData[5])}&message=${encodeURIComponent(CancelData[4])}&name=${encodeURIComponent(CancelData[0])}&phone=${encodeURIComponent(CancelData[2])}&email=${encodeURIComponent(CancelData[1])}&order_id=${encodeURIComponent(CancelData[3])}&%20key=dXZ1am9wN2VlYjY5ODg3OHlsMGhrem5tMGtqeGE2c3RmN281c3BhNWZoZGg2NHltb2E=`

                // Make the POST request
                fetch(url, {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
                    .then(response => {
                        // Handle the response
                        if (response.ok) {
                            console.log('Data posted successfully');
                            // Do something with the successful response
                        } else {
                            console.error('Error:', response.status);
                            // Handle the error response
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        // Handle any network or other errors
                    });
            })
        });
// order cancel and return  kapture crm api end
// order cancel and return page
$(document).ready(function (){
  $(".order_tr").click(function () {
   var order_id = $(this).find(".account-order-number a").attr("title");
    // alert(order_id);
    localStorage.setItem("lastname_order", order_id);  
  });
  var order_local = localStorage.getItem("lastname_order");
    $(".return_input_info input#order_id").val(order_local);
});

 $(document).ready(function(){
   $("#return-cancel-btn").click(function(){
    var name = document.getElementById("order_name_field").value;
    var email = document.getElementById("order_email_field").value;
    var number = document.getElementById("order_tel_field").value;
    var order_number = document.getElementById("order_id").value;
    var order_option = document.getElementById("order_option").getAttribute("value");
    var return_check = document.getElementById("return_check"); 
    if (name === "") {
    alert("Name is required");
    return false;
  }
  // Validate email field
  if (email === "") {
    alert("Email is required");
    return false;
  }
  // Regular expression to validate email format
  var emailRegex = /^\S+@\S+\.\S+(?:\s.*)?$/;

  if (!emailRegex.test(email)) {
    alert("Invalid email format");
    return false;
  }
  // Validate password field
  if (number === "") {
    alert("Phone No is required");
    return false;
  }  
  if (order_number === "") {
    alert("Order No is required");
    return false;
  }
     
  if (order_option === "") {
    alert("Option is required");
    return false;
  }
     if(return_check){
     // if(return_check !== null){
        if (!return_check.checked) {
          alert("Please agree to the terms and conditions");
          return false;
        }  
     }
     console.log("return_check 28");
     $("body").addClass("return_cancel_modal_2");
     $(".return_cancel_modal").addClass("return_cancel_d_block");
   });
   $(".return_cancel__close-button").click(function(){
     $("body").removeClass("return_cancel_modal_2");
     $(".return_cancel_modal").removeClass("return_cancel_d_block");
   });
 });

// order cancel and return page end
//Birth date validation 
function setAttr() {
    var d = new Date();
    var curr_date = d.getDate();
    var curr_month = d.getMonth() + 1; // Months are zero-based
    if (curr_month < 10)
        curr_month = '0' + curr_month;

    if (curr_date < 10)
        curr_date = '0' + curr_date;

    var curr_year = (d.getFullYear()) - 10;
    console.log(curr_year);
    var d1 = curr_year + "-" + curr_month + "-" + curr_date;
    console.log(d1);

    var dateInputs = document.querySelectorAll(".account_txtDate");

    dateInputs.forEach(function (input) {
        input.setAttribute("max", d1);
    });
}